// See data/injuries.ods for basketball data

const defaultInjuries: {
	name: string;
	frequency: number;
	games: number;
}[] = [
	{
		name: "Sprained Ankle",
		frequency: 1808,
		games: 3.46,
	},
	{
		name: "Patellar Tendinitis",
		frequency: 1493,
		games: 6.95,
	},
	{
		name: "Back Spasms",
		frequency: 999,
		games: 3.94,
	},
	{
		name: "Strained Hamstring",
		frequency: 413,
		games: 4.42,
	},
	{
		name: "Strained Groin",
		frequency: 394,
		games: 3.59,
	},
	{
		name: "Sprained Knee",
		frequency: 392,
		games: 11.15,
	},
	{
		name: "Plantar Fasciitis",
		frequency: 362,
		games: 5.64,
	},
	{
		name: "Bruised Quadriceps",
		frequency: 338,
		games: 1.41,
	},
	{
		name: "Bruised Knee",
		frequency: 321,
		games: 2.15,
	},
	{
		name: "Sprained Finger",
		frequency: 308,
		games: 1.09,
	},
	{
		name: "Strained Calf",
		frequency: 259,
		games: 8.02,
	},
	{
		name: "Bruised Leg",
		frequency: 227,
		games: 1.39,
	},
	{
		name: "Bruised Hip",
		frequency: 218,
		games: 1.14,
	},
	{
		name: "Sprained Foot",
		frequency: 207,
		games: 4.18,
	},
	{
		name: "Achilles Tendinitis",
		frequency: 204,
		games: 5.09,
	},
	{
		name: "Sprained Thumb",
		frequency: 196,
		games: 4.14,
	},
	{
		name: "Sprained Wrist",
		frequency: 181,
		games: 4.7,
	},
	{
		name: "Lacerated Eyelid",
		frequency: 172,
		games: 0.3,
	},
	{
		name: "Sprained Shoulder",
		frequency: 158,
		games: 7.35,
	},
	{
		name: "Strained Neck",
		frequency: 124,
		games: 1.21,
	},
	{
		name: "Herniated Disc",
		frequency: 110,
		games: 19.55,
	},
	{
		name: "Bruised Back",
		frequency: 109,
		games: 1.55,
	},
	{
		name: "Bruised Foot",
		frequency: 107,
		games: 2.38,
	},
	{
		name: "Fractured Foot",
		frequency: 106,
		games: 20.46,
	},
	{
		name: "Strained Foot",
		frequency: 102,
		games: 2.96,
	},
	{
		name: "Torn Meniscus",
		frequency: 102,
		games: 23.74,
	},
	{
		name: "Strained Quadriceps",
		frequency: 101,
		games: 3.09,
	},
	{
		name: "Fractured Hand",
		frequency: 100,
		games: 14.7,
	},
	{
		name: "Fractured Tooth",
		frequency: 90,
		games: 0.23,
	},
	{
		name: "Rotator Cuff Tendinitis",
		frequency: 89,
		games: 3.4,
	},
	{
		name: "Strained Hip Flexor",
		frequency: 87,
		games: 3.4,
	},
	{
		name: "Elbow Tendinitis",
		frequency: 84,
		games: 2.42,
	},
	{
		name: "Bruised Shoulder",
		frequency: 75,
		games: 0.83,
	},
	{
		name: "Concussion",
		frequency: 73,
		games: 3.01,
	},
	{
		name: "Fractured Nose",
		frequency: 73,
		games: 1.26,
	},
	{
		name: "Bruised Elbow",
		frequency: 72,
		games: 0.89,
	},
	{
		name: "Strained Rotator Cuff",
		frequency: 70,
		games: 3.87,
	},
	{
		name: "Bruised Hand",
		frequency: 69,
		games: 0.45,
	},
	{
		name: "Sprained Elbow",
		frequency: 64,
		games: 1.92,
	},
	{
		name: "Bruised Eye",
		frequency: 60,
		games: 0.32,
	},
	{
		name: "Strained Abdomen",
		frequency: 59,
		games: 5.8,
	},
	{
		name: "Strained Shoulder",
		frequency: 57,
		games: 1.18,
	},
	{
		name: "Fractured Finger",
		frequency: 52,
		games: 8.79,
	},
	{
		name: "Strained Patellar Tendon",
		frequency: 48,
		games: 9.46,
	},
	{
		name: "Peroneal Tendinitis",
		frequency: 45,
		games: 7.36,
	},
	{
		name: "Fractured Thumb",
		frequency: 40,
		games: 8.28,
	},
	{
		name: "Torn ACL",
		frequency: 40,
		games: 100,
	},
	{
		name: "Fractured Ankle",
		frequency: 24,
		games: 22,
	},
	{
		name: "Torn Achilles Tendon",
		frequency: 10,
		games: 100,
	},
];

export default defaultInjuries;
